// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.
import React, { useEffect } from "react";
import { Switch, InputGroup, TextArea, FormGroup } from "@blueprintjs/core";

const MaintenanceBannerConfig = ({ data, onToggle, onInputChange, onValidationChange }) => {
  useEffect(() => {
    const isValid = !data.isShowMaintenanceBanner || (
      data.maintenanceBannerTitle.trim() !== "" && data.maintenanceBannerContent.trim() !== ""
    );
    onValidationChange(isValid);
  }, [data, onValidationChange]);

  return (
    <div className="content">
      <div className="card">
        <div className="header">
          <div className="pull-left">
            <h5 className="title" style={{ marginBottom: "5px" }}>
              Maintenance Banner Settings
            </h5>
            <p className="category">
              Configure the banner displayed during maintenance
            </p>
          </div>
        </div>
        <div className="clearfix" />
        <div className="content" style={{ padding: "30px 45px" }}>
          <Switch
            innerLabelChecked="on"
            innerLabel="off"
            className="custom-switch"
            checked={data.isShowMaintenanceBanner}
            label="Show Maintenance Banner"
            onChange={() => onToggle("isShowMaintenanceBanner")}
            alignIndicator="right"
          />
          {data.isShowMaintenanceBanner && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <div className="category">Banner Title</div>
              <InputGroup
                name="maintenanceBannerTitle"
                value={data.maintenanceBannerTitle}
                onChange={onInputChange}
                className="input-field"
                intent={
                  data.maintenanceBannerTitle.trim() ? "none" : "danger"
                }
              />
              {!data.maintenanceBannerTitle.trim() && (
                <div className="error-message-title" style={{ color: "red", fontSize: "12px" }}>
                  Title cannot be empty
                </div>
              )}
              <div className="category">Banner Content</div>
              <div className="textarea-fields">
                <FormGroup label="" labelFor="text-input">
                  <TextArea
                    name="maintenanceBannerContent"
                    value={data.maintenanceBannerContent}
                    onChange={onInputChange}
                    className="textarea-field"
                    fill={true}
                    intent={
                      data.maintenanceBannerContent.trim() ? "none" : "danger"
                    }
                  />
                </FormGroup>
                {!data.maintenanceBannerContent.trim() && (
                  <div className="error-message-content" style={{ color: "red", fontSize: "12px" }}>
                    Content cannot be empty
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MaintenanceBannerConfig;
